/**
 * BugReportButton — robaczek w topbarze tenanta, otwiera widget „Zgłoś błąd".
 *
 * Wygląd dopasowany do dzwonka powiadomień obok (okrągły 40px, biały/elevated).
 * Kropka-wskaźnik pojawia się, gdy widget jest zminimalizowany z niepustym draftem —
 * sygnał „masz zaczęte zgłoszenie".
 */

import { useTranslation } from 'react-i18next';
import { Bug } from 'lucide-react';

import { IconButton } from '@/components/IconButton';
import { useBugReport } from '@/contexts/BugReportContext';
import { cn } from '@/lib/utils';

export function BugReportButton() {
  const { t } = useTranslation();
  const { status, hasDraft, open, restore } = useBugReport();

  const isActive = status !== 'closed';
  const showDraftDot = status === 'minimized' && hasDraft;

  return (
    <IconButton
      aria-label={t('tenant.bugReport.trigger')}
      title={t('tenant.bugReport.trigger')}
      aria-haspopup="dialog"
      aria-expanded={status === 'open'}
      onClick={() => (status === 'minimized' ? restore() : open())}
      data-testid="tenant-bug-report-trigger"
      className={cn(
        'relative h-10 w-10 rounded-full border shadow-[0_1px_1px_rgba(23,23,33,0.06)]',
        isActive
          ? 'border-accent-500/40 bg-accent-500/10 text-accent-600 hover:bg-accent-500/15 hover:text-accent-600'
          : 'border-border-secondary bg-bg-elevated text-text-secondary',
      )}
    >
      <Bug size={20} aria-hidden="true" />
      {showDraftDot && (
        <span
          aria-hidden="true"
          className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-accent-500 ring-2 ring-bg-elevated"
        />
      )}
    </IconButton>
  );
}
